import React from "react";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import { CloseIcon, DeleteIcon } from "../../assets/icons";
import styles from "./Confirm.module.scss";

function Confirm({
  open,
  title = "Are you sure you want to delete this?",
  description = "You can't undo this deletion, so double-check what you're deleting.",
  confirmText = "Delete",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <Modal
      close={false}
      onClose={onCancel}
      containerClassName={styles.confirmModalContainer}
      className={styles.confirmContent}
      title={null}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>

        <div className={styles.actionRow}>
          <Button
            text={cancelText}
            className={styles.cancelBtn}
            prefixIcon={<CloseIcon />}
            onClick={onCancel}
          />
          <Button
            text={confirmText}
            outlined
            className={styles.confirmBtn}
            prefixIcon={<DeleteIcon />}
            onClick={onConfirm}
          />
        </div>
      </div>
    </Modal>
  );
}

export default Confirm;
